<div class="toast" *ngFor="let alert of alerts">
    <p>{{alert.message}}</p>
    <button class="button button--inverted" (click)="removeAlert(alert)">{{alert.actionLabel}}</button>
</div>